import axios, { AxiosResponse } from 'axios';

import {
    ExportTaskCreateRequest,
    ExportTaskCreateResponse,
    ExportTasksFilterRequest,
    ExportTasksFilterResponse,
    ExportTasksResponse,
    InfoExportResponseData
} from '../../../../pages/import/types';
import { axiosConfigAuth } from '../middleware';
import {
    API_CREATE_EXPORT_TASK,
    API_DELETE_EXPORT_TASKS,
    API_GET_EXPORT_INFO,
    API_GET_EXPORT_TASKS_FILTER
} from '../urls';

export const importApi = {
    getInfoExport: async (): Promise<AxiosResponse<ExportTasksResponse<InfoExportResponseData>>> =>
        axios.get(API_GET_EXPORT_INFO, axiosConfigAuth()),

    getExportTasksInFilter: async (
        payload: ExportTasksFilterRequest
    ): Promise<AxiosResponse<ExportTasksFilterResponse>> =>
        axios.post(API_GET_EXPORT_TASKS_FILTER, payload, axiosConfigAuth()),

    createExportTask: async (
        payload: ExportTaskCreateRequest
    ): Promise<AxiosResponse<ExportTaskCreateResponse>> =>
        axios.post(API_CREATE_EXPORT_TASK, payload, axiosConfigAuth()),

    deleteExportTask: async (
        taskId: number
    ): Promise<AxiosResponse<ExportTasksResponse<never>>> =>
        axios.delete(API_DELETE_EXPORT_TASKS.replace(':task_id', String(taskId)), axiosConfigAuth())
};
